import { Action, ThunkDispatch, configureStore, combineReducers } from '@reduxjs/toolkit'
import * as LogRocket from 'logrocket'
import authReducer from '../slices/auth'
import clientsReducer from '../slices/clients'
import projectsReducer from '../slices/projects'
import quotesReducer from '../slices/quotes'
import settingsReducer from '../slices/settings'
import commonReducer from '../slices/common'
import contactsReducer from '../slices/contacts'
import proposalsReducer from '../slices/proposals'
import invoicesReducer from '../slices/invoices'
import suppliersReducer from '../slices/suppliers'
import purchasesReducer from '../slices/purchases'
import purchaseordersReducer from '../slices/purchaseOrders'

const store = configureStore({
  reducer: {
    auth: authReducer,
    clients: clientsReducer,
    projects: projectsReducer,
    quotes: quotesReducer,
    settings: settingsReducer,
    common: commonReducer,
    contacts: contactsReducer,
    proposals: proposalsReducer,
    invoices: invoicesReducer,
    suppliers: suppliersReducer,
    purchases: purchasesReducer,
    purchaseorders: purchaseordersReducer,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(LogRocket.reduxMiddleware()),
})

export default store

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export type ThunkAppDispatch = ThunkDispatch<RootState, void, Action>
